export const Logo = ({className}: {className?: string}) => {
    return <h1 className={className} style={{fontFamily: 'Silkscreen, cursive'}}>Brua</h1>
}